"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;
var _definitions = require("@ppay/definitions");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactI18next = require("react-i18next");
var _lodash = _interopRequireDefault(require("lodash.get"));
var _interfaces = require("../../../interfaces");
var _state = require("../../../state");
var _Component = require("./Component");
var _decimal = _interopRequireDefault(require("decimal.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Container = function Container(_ref) {
  var _location$state, _dates$, _dates$2;
  var title = _ref.title,
    subtitle = _ref.subtitle,
    _ref$useTransactions = _ref.useTransactions,
    useTransactions = _ref$useTransactions === void 0 ? _state.useTransactions : _ref$useTransactions,
    noData = _ref.noData,
    showModalViewAll = _ref.showModalViewAll;
  var location = (0, _reactRouterDom.useLocation)();
  var _useState = (0, _react.useState)(location && (_location$state = location.state) !== null && _location$state !== void 0 && _location$state.ticker ? [location.state.ticker] : [].concat(_toConsumableArray(_definitions.CRYPTO_TICKERS), _toConsumableArray(_definitions.FIAT_BALANCE_TICKERS))),
    _useState2 = _slicedToArray(_useState, 2),
    tickers = _useState2[0],
    setTickers = _useState2[1];
  var _useState3 = (0, _react.useState)(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    type = _useState4[0],
    setType = _useState4[1];
  var _useState5 = (0, _react.useState)((0, _lodash.default)(location, 'state.search', '')),
    _useState6 = _slicedToArray(_useState5, 2),
    search = _useState6[0],
    setSearch = _useState6[1];
  var _useState7 = (0, _react.useState)([null, null]),
    _useState8 = _slicedToArray(_useState7, 2),
    dates = _useState8[0],
    setDates = _useState8[1];
  var _useState9 = (0, _react.useState)(''),
    _useState10 = _slicedToArray(_useState9, 2),
    minAmount = _useState10[0],
    setMinAmount = _useState10[1];
  var _useState11 = (0, _react.useState)(''),
    _useState12 = _slicedToArray(_useState11, 2),
    maxAmount = _useState12[0],
    setMaxAmount = _useState12[1];
  var _useTranslation = (0, _reactI18next.useTranslation)(['libTransactionsTable', 'libTransaction']),
    t = _useTranslation.t;
  var _useTransactions = useTransactions(),
    transactionsState = _useTransactions.transactionsState,
    hasMore = _useTransactions.hasMore,
    fetchTransactions = _useTransactions.fetchTransactions,
    fetchMoreTransactions = _useTransactions.fetchMoreTransactions,
    saveCSV = _useTransactions.saveCSV;
  var fetchParams = {
    tickers: tickers,
    type: type,
    search: search,
    dateFrom: (_dates$ = dates[0]) !== null && _dates$ !== void 0 ? _dates$ : undefined,
    dateTo: (_dates$2 = dates[1]) !== null && _dates$2 !== void 0 ? _dates$2 : undefined,
    minAmount: minAmount === '' ? undefined : minAmount,
    maxAmount: maxAmount === '' ? undefined : maxAmount
  };
  (0, _react.useEffect)(function () {
    fetchTransactions(fetchParams);
  }, [tickers, type]);
  var onSearchClick = function onSearchClick() {
    fetchTransactions(fetchParams);
  };
  var loadMore = function loadMore() {
    fetchMoreTransactions(fetchParams);
  };
  var onReset = function onReset() {
    fetchTransactions({
      tickers: [].concat(_toConsumableArray(_definitions.CRYPTO_TICKERS), _toConsumableArray(_definitions.FIAT_BALANCE_TICKERS))
    });
    setSearch('');
    setTickers([].concat(_toConsumableArray(_definitions.CRYPTO_TICKERS), _toConsumableArray(_definitions.FIAT_BALANCE_TICKERS)));
    setType(undefined);
    setDates([null, null]);
    setMinAmount('');
    setMaxAmount('');
  };
  var onDownload = function onDownload() {
    saveCSV(fetchParams);
  };
  var paymentTypeOptions = [{
    value: 'ALL',
    label: t('allPaymentTypes')
  }, {
    value: _interfaces.TransactionType.DEPOSIT,
    label: t("libTransaction:type.".concat(_interfaces.TransactionType.DEPOSIT))
  }, {
    value: _interfaces.TransactionType.WITHDRAWAL,
    label: t("libTransaction:type.".concat(_interfaces.TransactionType.WITHDRAWAL))
  }, {
    value: _interfaces.TransactionType.EXCHANGE,
    label: t("libTransaction:type.".concat(_interfaces.TransactionType.EXCHANGE))
  }];
  return /*#__PURE__*/_react.default.createElement(_Component.Component, {
    paymentTypeOptions: paymentTypeOptions,
    onTypeChange: function onTypeChange(selected) {
      return selected === 'ALL' ? setType(undefined) : setType(selected);
    },
    transactions: transactionsState.data,
    isLoading: transactionsState.loading,
    isCSVLoading: transactionsState.csvLoading,
    loadMore: loadMore,
    hasMore: hasMore,
    tickers: tickers,
    type: type,
    onDownload: onDownload,
    searchValue: search,
    onTickersChange: setTickers,
    onSearchInputChange: function onSearchInputChange(e) {
      return setSearch(e.target.value);
    },
    onSearchClick: onSearchClick,
    onReset: onReset,
    title: title,
    subtitle: subtitle,
    noData: noData,
    setMinAmount: setMinAmount,
    setMaxAmount: setMaxAmount,
    maxAmount: maxAmount,
    minAmount: minAmount,
    onDateChange: function onDateChange(date) {
      return setDates(date);
    },
    dates: dates,
    showModalViewAll: showModalViewAll,
    amountsInvalid: minAmount && maxAmount ? new _decimal.default(minAmount).greaterThan(maxAmount) : false
  });
};
exports.Container = Container;